import React from "react";
import { useWeb3React } from "@web3-react/core";
import ModalWrapper from "components/ModalWrapper/ModalWrapper";
import Button from "components/Button/Button";
import "./ConfirmModal.scss";

function ConfirmModal({ setModalOpen, modalOpen, activatingConnector }: any) {
  const { activate } = useWeb3React();
  return (
    <ModalWrapper contentLabel="warning" setShowModal={setModalOpen} showModal={modalOpen}>
      <div className="warning">
        <h2>Warning</h2>
        {/* <div className="close-modal" onClick={() => setModalOpen(false)}>
          𝗫
        </div> */}
        <div className="warning-text">
          Yearn Generation of Yield (YGY) is an experimental product, and as such all investors and users must be aware of all inherent
          risks. All of our contracts are available for review on our{" "}
          <a href="https://github.com/orgs/Yearn-Generation-of-Yield/dashboard" target="blank" rel="noopener noreferrer">
            GitHub.
          </a>
        </div>
        <Button type="neutral" onClick={() => activate(activatingConnector)}>
          I UNDERSTAND THE RISKS
        </Button>
      </div>
    </ModalWrapper>
  );
}

export default ConfirmModal;
